class CollapsibleAccordion {
  constructor() {
    this.detailsElements = document.querySelectorAll('.accordion details');
    this.init();
  }

  init() {
    // Add click event listeners to all summary elements
    this.detailsElements.forEach(details => {
      const summary = details.querySelector('summary');
      summary.addEventListener('click', (e) => {
        // Prevent default behavior so we can control it
        e.preventDefault();
        this.handleClick(details);
      });
    });
  }

  handleClick(clickedDetails) {
    // If the clicked details is already open, just close it
    if (clickedDetails.hasAttribute('open')) {
      clickedDetails.removeAttribute('open');
        console.log('temove 24')
      return;
    }

    // Close all other open details elements
    this.detailsElements.forEach(details => {
      console.log('temove 24')
      if (details !== clickedDetails && details.hasAttribute('open')) {
        details.removeAttribute('open');
      }
    });

    // Open the clicked details
    clickedDetails.setAttribute('open', '');
  }
}

// Initialize the accordion when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CollapsibleAccordion();
});

// Re-initialize when Shopify section is reloaded
document.addEventListener('shopify:section:load', () => {
  new CollapsibleAccordion();
});